import store from '../../store/store';
export default function getClauseIdsForSectionType(sectionType) {
    switch (sectionType) {
        case 'conditional':
            return store.inboxRulesEditState.conditionalClauseIds;
        case 'action':
            return store.inboxRulesEditState.actionClauseIds;
        case 'exception':
            return store.inboxRulesEditState.exceptionClauseIds;
        default:
            throw new Error('Cannot get clause ids for a section type that does not exist');
    }
}
//# sourceMappingURL=getClauseIdsForSectionType.js.map